import Backbone from 'backbone'
import _ from 'lodash'
import Finder from 'scoreboard/components/finder'
import selects from 'scoreboard/components/selects'
import template from './divided-list.hbs'
import itemTemplate from './divided-list-item.hbs'
import HoverActions from 'scoreboard/components/hover-actions'
import i18n from 'scoreboard/components/i18n'

const DividedList = Backbone.View.extend({

	className: 'divided-list-container form object-selector',

	events : {
		'mouseover .label-mask' : 'onMouseOverLabelMask',
		'mouseout li.divided-list-item' : 'onMouseOutListItem',
		'mouseout' : 'onMouseOut',
		'click li.divided-list-item' : 'onClickListItem',
		'click .item-action': 'onClickListAction'
	},

	initialize(options = {}) {
		this.options = options
		this.data = _.cloneDeep(this.options.options)
		this.options.sortFields = [
			{ field: 'sortGroup', direction: 'asc' },
			{ field: 'sortLabel', direction: 'asc' }
		]
		this.filter = selects.siftFunction(_.defaults({options: this.data}, this.options))
	},

	attachListeners() {
		this.finder.on('find', search => this.render(this.getTreeOptions(search)))
	},

	render() {
		this.$el.append(template())

		_.invoke(this.finder, 'remove')
		this.finder = new Finder({
			el: this.$('.finder'),
			type: 'light',
			autofocus: true
		}).render()

		this.renderList(this.data)

		// Prevent the list's height from jumping around while searching by setting
		// a fixed height. We can capture the height when the finder is focused to
		// ensure we have an accurate height and it only needs to happen once.
		this.$(this.finder.el).find('input').one('focus', () => {
			let treeContainer = this.$('.tree-container')
			// Get the height when all of the content is present
			let height = treeContainer.height()
			// Set that height as a fixed height so it won't change.
			treeContainer.height(height)
		})

		this.finder.on('find', search => {
			let data = _.isNil(search) ? this.data : this.filter(search)
			this.renderList(data)
		})
	},

	getIcon(dataType) {
		switch (dataType) {
			case 'date': return 'calendar'
			case 'calendar-period': return 'calendar'
			case 'yes-no': return 'yes-no-data-type'
			case 'rollup': return 'rollup-tree'
			case 'time': return 'clock'
			default: return dataType
		}
	},

	renderList(listData) {
		let list = this.$('.divided-list').empty()
		let currentGroup
		listData.forEach(data => {
			let context = _.extend({}, data)
			let { group, icon, dataType, customIcon } = context
			//'headerless' the magic string for the ungrouped group
			if (group && group != 'headerless' && currentGroup != group) {
				currentGroup = group
				list.append(`<li class="divider-label">${_.escape(group)}</li>`)
			}

			if (customIcon) {
				context.icon = this.getIcon(customIcon)
			} else if (!icon) {
				context.icon = this.getIcon(dataType)
			}
			list.append(itemTemplate(context))
		})

		// Set the button text (e.g. Add)
		let buttonContent = this.options.buttonLabel || i18n.get('common.select')

		if (this.hoverActions) {
			//rebind the events on the new list elements
			this.hoverActions.setElement(list)
		} else {
			this.hoverActions = new HoverActions({
				el: list, // Attach the tree to the view
				tree: this.$('.tree')[0], // Pass the tree to the view
				propagateClick: true, //allow click to bubble up to this view
				buttonContent
			}).render()
		}
	},

	onClickListItem(e) {
		this.$('.divided-list li').removeClass('selected')
		this.$(e.target).closest('li').addClass('selected')
	},

	onClickListAction(e) {
		e.stopPropagation()
		let id = this.$(e.target).closest('li').data('id')
		this.trigger('click', id)
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.finder, this.hoverActions], 'remove')
	}
})




export default DividedList
DividedList.__filename__ = 'components/divided-list.js'
